export default {
  isTestnet: true,
  explorerLink: 'https://alfajores-blockscout.celo-testnet.org/tx/'
}
